class MHeader extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      headers: ["header"],
      logos: [".m-logo"],
      topbar: ".m-topbar",
      headerWrapper: ".m-header__wrapper",
      topbarClose: ".m-topbar__close",
    };

    this.domNodes = queryDomNodes(this.selectors, this);
    this.innerWidth = window.innerWidth;
    this.headerOffsetTop = this.domNodes.headerWrapper.offsetTop;
    this.headerHeight = this.domNodes.headerWrapper.offsetHeight;
    this.stickyHeader = this.dataset.sticky;

    this.classes = {
      scrollUp: "scroll-up",
      scrollDown: "scroll-down",
      stuck: "stuck",
      always: "header-sticky-always",
      headerScrollUp: "header-scroll-up",
      headerScrollDown: "header-scroll-down",
    };

    this._stickyScrollHandler = null;
    this.init();
  }

  init() {
    this.transparentHeader =
      this.domNodes &&
      this.domNodes.headers[0] &&
      this.domNodes.headers[0].dataset.transparent === "true";

    this.initAddon();
    this.handleSticky();

    document.addEventListener("matchMobile", () => this.handleSticky());
    document.addEventListener("unmatchMobile", () => this.handleSticky());

    this.siteNav = new SiteNav(this);
    window.__sfHeader = this;

    window.addEventListener("resize", () => {
      this.innerWidth = window.innerWidth;
      this.handleSticky();
    });
  }

  initAddon() {
    this.megamenu = new Megamenu(this);

    if (Shopify.designMode) {
      MinimogTheme = MinimogTheme || {};
      MinimogTheme &&
        MinimogTheme.Wishlist &&
        MinimogTheme.Wishlist.updateWishlistCount();
    }
  }

  handleSticky() {
    let extraSpace = 20;

    const sectionGroups = document.querySelectorAll(
      ".shopify-section-group-header-group"
    );

    sectionGroups.forEach((section) => {
      if (
        !section.classList.contains("m-section-header") &&
        !section.classList.contains("m-section-scaling-logo")
      ) {
        extraSpace += section.offsetHeight;
      }
    });

    const desktopStickySetting = this.dataset.sticky || "on_scroll_up";

    const updateStickyMode = () => {
      const isMobile = window.innerWidth < 1024;

      if (isMobile) {
        // Mobile: keep header visible from initial page load.
        this.stickyHeader = "always";
        this.classList.add(this.classes.always);

        this.classList.remove(
          this.classes.stuck,
          this.classes.scrollUp,
          this.classes.scrollDown
        );

        document.body.classList.remove(
          this.classes.headerScrollUp,
          this.classes.headerScrollDown
        );
      } else {
        // Desktop: preserve the original theme behavior.
        this.stickyHeader = desktopStickySetting;
        this.classList.remove(this.classes.always);
      }
    };

    updateStickyMode();

    if (this._stickyScrollHandler) {
      window.removeEventListener("scroll", this._stickyScrollHandler);
    }

    let lastScroll = window.scrollY;

    this._stickyScrollHandler = () => {
      const currentScroll = window.scrollY;
      const isMobile = window.innerWidth < 1024;

      if (isMobile) {
        // Keep mobile header visible while scrolling.
        this.classList.add(this.classes.always);

        this.classList.remove(
          this.classes.stuck,
          this.classes.scrollUp,
          this.classes.scrollDown
        );

        document.body.classList.remove(
          this.classes.headerScrollUp,
          this.classes.headerScrollDown
        );

        lastScroll = currentScroll;
        return;
      }

      // Desktop behavior.
      this.classList.remove(this.classes.always);

      if (currentScroll <= extraSpace) {
        this.classList.remove(
          this.classes.scrollUp,
          this.classes.scrollDown,
          this.classes.stuck
        );

        document.body.classList.remove(
          this.classes.headerScrollUp,
          this.classes.headerScrollDown
        );

        lastScroll = currentScroll;
        return;
      }

      if (this.stickyHeader === "on_scroll_up") {
        this.classList.add(this.classes.stuck);
      } else if (this.stickyHeader === "always") {
        this.classList.add(this.classes.always);
      }

      if (
        currentScroll > this.headerHeight + extraSpace &&
        currentScroll > lastScroll &&
        !this.classList.contains(this.classes.scrollDown)
      ) {
        this.classList.remove(this.classes.scrollUp);
        document.body.classList.remove(this.classes.headerScrollUp);

        this.classList.add(this.classes.scrollDown);
        document.body.classList.add(this.classes.headerScrollDown);
      } else if (
        currentScroll < lastScroll &&
        this.classList.contains(this.classes.scrollDown)
      ) {
        this.classList.remove(this.classes.scrollDown);
        document.body.classList.remove(this.classes.headerScrollDown);

        this.classList.add(this.classes.scrollUp);
        document.body.classList.add(this.classes.headerScrollUp);
      }

      lastScroll = currentScroll;
    };

    window.addEventListener("scroll", this._stickyScrollHandler, {
      passive: true,
    });
  }
}

customElements.define("m-header", MHeader);